export default "__VITE_PUBLIC_ASSET__58834073__"